import { ShieldCheck } from "lucide-react";

export const AccountBadges = ({ a }) => (
  <span className="flex flex-wrap justify-end gap-1">
    {a.is_default && <span className="rounded-full bg-[#F7931A]/15 px-2 py-0.5 text-[10px] font-semibold uppercase text-[#F7931A]" data-testid={`account-default-badge-${a.account_id}`}>Default</span>}
    {a.trusted && (
      <span className="inline-flex items-center gap-1 rounded-full bg-emerald-500/10 px-2 py-0.5 text-[10px] font-semibold uppercase text-emerald-400" data-testid={`account-trusted-badge-${a.account_id}`}>
        <ShieldCheck size={10} /> Trusted
      </span>
    )}
  </span>
);
